import { routes } from '@constants';

export const dropdownLanguageItems = [
  { id: 'en', label: 'EN' },
  { id: 'ua', label: 'UA' },
];

export const navBarItemsProps = [
  {
    id: 0,
    route: routes.courses,
    titleText: 'Footer.Courses',
    type: 'courses',
  },
  {
    disableIfUnauthorized: true,
    id: 1,
    route: routes.learningMap,
    titleText: 'Footer.LearningMap',
    type: 'certification_test',
  },
  {
    id: 2,
    route: routes.activities,
    titleText: 'Footer.Activities',
    type: 'activity',
  },
];

export const getDropdownProfileItems = ({ t }) => [
  {
    id: routes.profile,
    label: t('ProfileDropdown.Profile'),
  },
  {
    id: routes.settings,
    label: t('ProfileDropdown.Settings'),
  },
  {
    id: routes.offlineContent,
    label: t('ProfileDropdown.OfflineContent'),
  },
  {
    id: 'signOut',
    label: t('ProfileDropdown.LogOut'),
  },
];
